import { FlightpathMissionStatusMessage } from '../FlightpathMissionStatusMessage';
import { MachineKey } from '../MachineKey';
import { RosAutoTransitionRequirementsMessage } from './RosAutoTransitionRequirementsMessage';
import { RosMissionStatusMessage } from './RosMissionStatusMessage';

export interface MissionStatusAutoTransitionMessage {
  Key: MachineKey;
  SentUTC: string;
  RosMissionStatus: RosMissionStatusMessage;
  FlightPathMissionStatus: FlightpathMissionStatusMessage;
  AutoTransitionRequirements: RosAutoTransitionRequirementsMessage;
}

// Converts JSON strings to/from your types
export class ConvertMissionStatus {
  public static stringToMissionStatusModel(json: string): MissionStatusAutoTransitionMessage {
    return JSON.parse(json);
  }
}
